// extracted by mini-css-extract-plugin
export default {"spinner":"wse3uxyR","rotate":"JPlipqdM"};